import { render, staticRenderFns } from "./LastHourDiagnosisChart.vue?vue&type=template&id=0db8e73f&scoped=true"
import script from "./LastHourDiagnosisChart.vue?vue&type=script&lang=ts"
export * from "./LastHourDiagnosisChart.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0db8e73f",
  null
  
)

export default component.exports